import { Nullable } from '@aibees/shared/definition';
import { SocialMediaItem } from '../search-social-media/types';
import { SocialLink } from './types';

export function isSocialMediaLinkAvailable(
  item: SocialMediaItem,
  socialLink?: Nullable<SocialLink>
) {
  return !!socialLink?.[item.type as keyof SocialLink];
}

export function getSocialMediaLink(
  item: SocialMediaItem,
  socialLink?: Nullable<SocialLink>
) {
  if (socialLink) {
    return socialLink[item.type as keyof SocialLink]?.toString();
  }
  return undefined;
}
